<template>
    <tr>
        <td scope="row">{{userCase.id}}</td>
        <td>{{new Date(userCase.created_at).toLocaleTimeString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}}</td>
        <td>{{userCase.city}}</td>
        <td class="text-center">{{userCase.issuer.name}}</td>
        <td v-if="user.type == 'admin'" class="text-center">{{userCase.entity}}</td>
        <td class="text-center"><p :class="{'reviewed':userCase.status=='Revisado', 'pending':userCase.status=='Pendiente'}">{{userCase.status}}</p></td>
        <td>
            <router-link class="btn btn-success btn-sm" :to="{name: 'case', params:{id: userCase.id}}"  @click="$emit('goToCase')">
                <i class="fa fa-eye"></i>
            </router-link>
        </td>
        <td>
            <a class="btn btn-danger btn-sm" target="_blank" :href="pdfLink">
                <i class="fas fa-file-pdf"></i>
            </a>
        </td>
    </tr>
</template>
<script>
export default {
    name: 'caseComponent',
    props: {
        userCase: {
            type: Object,
            required: true,
        }
    },
    data(){
        return {
            apiURL: process.env.VUE_APP_API,
            token: localStorage.getItem("session_id"),
            user: JSON.parse(localStorage.getItem("user"))
        }
    },
    computed: {
        pdfLink: function(){
            return `${this.apiURL}/${this.user.type}/cases-pdf/${this.userCase.id}?token=${this.token}`
        }
    }
}
</script>
<style scoped>
    .pending {
        background-image: linear-gradient(orange, darkorange);
        color: white;
        margin: 0px;
        border-radius: 5px;
    }

    .reviewed {
        background-image: linear-gradient(rgb(0, 163, 0), rgb(65, 241, 65));
        color: white;
        margin: 0px;
        border-radius: 5px;
    }
</style>




